import "./style.css";
import lod_ from "lodash";
import MDBox from "components/Basics/MDBox";
import MDTypography from "components/Basics/MDTypography";
import { Chip, Divider, Icon } from "@mui/material";
import Message from "./Message";
import { t } from "i18next";

/**
 * Conversation Tab component to display the messages of a conversation.
 * @param {Object} conversation - The conversation object containing messages.
 * @param {Object} resource - The resource configuration.
 * @return {JSX.Element} The rendered ConversationTab component.
 */
const ConversationTab = ({ conversation, resource, tabMessage, hasTabs }) => {
	const conversationHasMessages =
		!lod_.isEmpty(conversation?.messages) && !lod_.isNil(conversation?.messages);

	if (lod_.isNil(conversation)) {
		return (
			<MDBox
				display="flex"
				flexDirection="column"
				alignItems="center"
				justifyContent="center"
				sx={{ py: 8 }}
			>
				<Icon sx={{ fontSize: "48px !important", color: "#ccc", mb: 1 }}>chat_bubble_outline</Icon>
				<MDTypography variant="body2" color="secondary">
					{t("FORMS.RESOURCE.PHONECALL.noConversationAvailable")}
				</MDTypography>
			</MDBox>
		);
	}

	return (
		<MDBox display="flex" flexDirection="column" sx={{ height: "100%", overflow: "hidden" }}>
			<Divider sx={{ my: 0.5 }} />

			{/* Messages list */}
			<MDBox
				sx={{
					flex: 1,
					overflowY: "auto",
					px: 1.5,
					py: 1.5,
					backgroundColor: "#f8f9fa",
					"&::-webkit-scrollbar": { width: 6 },
					"&::-webkit-scrollbar-thumb": {
						backgroundColor: "#ccc",
						borderRadius: 3
					}
				}}
			>
				{conversationHasMessages === true ? (
					conversation.messages.map((message, index) => (
						<Message key={index} message={message} tabMessage={tabMessage} />
					))
				) : (
					<MDBox display="flex" justifyContent="center" sx={{ py: 4 }}>
						<MDTypography variant="body2" color="secondary" fontSize="small">
							Aucun message
						</MDTypography>
					</MDBox>
				)}
			</MDBox>
		</MDBox>
	);
};

export default ConversationTab;
